import React from 'react';

import cx from 'classnames';

import SAFARI_PORTAL_LOGO from 'components/shared/images/safari_portal.svg';
import styles from 'components/shared/LandingPage/blocks/PageHeader/index.module.css';
import Text from 'components/shared/Typography/Text';

import { useLandingV2Context } from '../../context';
import { getPrefix } from '../../utils';
import s from './index.module.css';

const TopBar = () => {
  const { data, rightActions, leftActions, config } = useLandingV2Context();

  const logoSrc = data.account?.logo?.url;
  const companyName = data.account?.companyName;

  const brandLogoSrc = data.brandSettings?.logo?.url;
  const brandCompanyName = data.brandSettings?.companyName;

  const whiteLabelingOn = data?.whiteLabelingOn;
  const whiteLabelingDisplayCompanyLogo = data?.whiteLabelingDisplayCompanyLogo;

  const renderLogo = (logoSrc?: string, companyName?: string) => {
    if (!logoSrc && companyName) {
      return (
        <Text hoefler italic className={cx(styles.companyName, s.companyName, getPrefix('right-header-companyname'))}>
          {companyName}
        </Text>
      );
    }
    return (
      <img src={logoSrc || SAFARI_PORTAL_LOGO} alt="logo" className={getPrefix('right-header-logo')} crossOrigin="" />
    );
  };

  const renderBrandLogo = () => {
    if (!whiteLabelingOn) return null;
    return renderLogo(brandLogoSrc, brandCompanyName);
  };

  const renderCompanyLogo = () => {
    if (whiteLabelingOn) {
      if (!whiteLabelingDisplayCompanyLogo) return null;
    }
    return renderLogo(logoSrc, companyName);
  };

  const leftActionsAvailable = config.header && !!config.header.topBar && config.header.topBar.leftActions;

  return (
    <div className={cx(getPrefix('top-bar'), s.topBar)}>
      {/*@ts-ignore*/}
      <div className={s.leftActionsContainer}>{leftActionsAvailable ? leftActions : null}</div>
      <div className={cx(styles.headerLogo, getPrefix('right-header-logo'))}>
        {renderBrandLogo()}
        {renderCompanyLogo()}
      </div>
      <div className={s.rightActionsContainer}>{rightActions}</div>
    </div>
  );
};

export default TopBar;
